export default (odds: number) => {
  return odds >= 2 ? `+${((odds - 1) * 100).toFixed(0)}` : (-100 / (odds - 1)).toFixed(0);
};
